import enMessages from './en';
import esMessages from './es';
import deMessages from './de';

export const messages = { 'en-US': enMessages, 'es-ES': esMessages, 'de-DE': deMessages };
